// extracted by mini-css-extract-plugin
export default {"column":"ReportFilter_column__ptnNN","placeHolderShimmer":"ReportFilter_placeHolderShimmer__RDm+x"};